"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroqModelModel = void 0;
exports.GroqModelModel = {
    Llama3370BVersatile: "llama-3.3-70b-versatile",
    Llama31405BReasoning: "llama-3.1-405b-reasoning",
    Llama3170BVersatile: "llama-3.1-70b-versatile",
    Llama318BInstant: "llama-3.1-8b-instant",
    Mixtral8X7B32768: "mixtral-8x7b-32768",
    Llama38B8192: "llama3-8b-8192",
    Llama370B8192: "llama3-70b-8192",
    Gemma29BIt: "gemma2-9b-it",
};
